<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <h5 style="color:white; background:#112f4e;" class="px-3"><b>{{'PROJECTS_UNDER_MICRO_IRRIGATION'| translate}}</b>
  </h5>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
      <b>i) {{'PROJECTS_UNDER_MICRO_IRRIGATION_1'| translate}} <br><br>
          ii) {{'PROJECTS_UNDER_MICRO_IRRIGATION_2'| translate}}<br><br>
          iii) {{'PROJECTS_UNDER_MICRO_IRRIGATION_3'| translate}}
      </b>
  </p>

  <h5 style="color:white; background:#112f4e;" class="px-3"><b>{{'ON_GOING_PROJECT'| translate}}</b>
  </h5>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
      <b>iv) {{'PROJECTS_UNDER_MICRO_IRRIGATION_4'| translate}}<br>
      </b>
  </p>
<!-- </div> -->